document.querySelectorAll('[data-header-behaviour="fixed"], [data-header-behaviour="disappear"]').forEach((header) => {
  const behaviour = header.dataset.headerBehaviour;
  const announcementBar = document.querySelector('.announcement-bar');
  const stack = announcementBar ? [announcementBar, header] : [header];

  let stackHeight = 0;

  const layout = () => {
    let offset = 0;
    stack.forEach((el) => {
      el.style.position = 'fixed';
      el.style.insetInlineStart = '0';
      el.style.insetInlineEnd = '0';
      el.style.top = `${offset}px`;
      el.style.zIndex = '50';
      offset += el.offsetHeight;
    });
    stackHeight = offset;
    document.body.style.paddingTop = `${stackHeight}px`;
    // Exposed so other sections (e.g. a sticky sidebar) can offset
    // themselves below the fixed/disappearing header group without
    // duplicating this measurement.
    document.documentElement.style.setProperty('--sticky-header-offset', `${stackHeight}px`);
  };

  layout();
  window.addEventListener('resize', layout);

  if (behaviour !== 'disappear') return;

  stack.forEach((el) => {
    el.style.transition = 'transform 0.3s ease';
  });

  const threshold = 10;
  let lastScrollY = window.scrollY;
  let hidden = false;
  let mobileMenuOpen = false;

  const setHidden = (state) => {
    if (state === hidden) return;
    hidden = state;
    const transform = hidden ? `translateY(-${stackHeight}px)` : 'translateY(0)';
    stack.forEach((el) => {
      el.style.transform = transform;
    });
  };

  document.addEventListener('header:mobile-menu-toggle', (event) => {
    mobileMenuOpen = event.detail.open;
    if (mobileMenuOpen) {
      setHidden(false);
    } else {
      lastScrollY = window.scrollY;
    }
  });

  window.addEventListener(
    'scroll',
    () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        setHidden(false);
      } else if (currentScrollY > lastScrollY + threshold) {
        if (!mobileMenuOpen) setHidden(true);
        lastScrollY = currentScrollY;
      } else if (currentScrollY < lastScrollY - threshold) {
        setHidden(false);
        lastScrollY = currentScrollY;
      }
    },
    { passive: true }
  );
});
